export const getBundles = (state) => state.bundles?.list ?? [];

export const getBundlesById = (state) => state.bundles?.listById ?? {};

export const getBundleData = (state, id) => state.bundles?.list.find((bundle) => bundle.id === id);

export const getActiveBundleId = (state) => {
    return state?.bundles?.activeId;
};
